import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import ToTop from "../../../static/flaticons/arrow-small-up.svg";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show or hide the button based on scroll position
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll effect
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <div className={styles.toTop} onClick={scrollToTop}>
          <ToTop height="20" width="20" fill="white" />
        </div>
      )}
    </div>
  );
};

export default ScrollToTop;
